<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="供应商管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="供应商类型">
									<el-select v-model="searchForm.type" placeholder="请选择" style="width: 100%;">
										<el-option v-for="item in options.type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="供应商名称">
									<el-input v-model="searchForm.supplier_name" placeholder="请填写供应商名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="供应商简称">
									<el-input v-model="searchForm.short_name" placeholder="请填写供应商简称" clearable></el-input>
								</el-form-item>
								<el-form-item label="供应商编码">
									<el-input v-model="searchForm.supplier_code" placeholder="请填写供应商编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="税号/身份证">
									<el-input v-model="searchForm.id_number" placeholder="请填写税号或身份证" clearable></el-input>
								</el-form-item>
								<el-form-item label="是否统一结算">
									<el-select v-model="searchForm.is_payment" placeholder="请选择结算类型" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_payment_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="是否停用">
									<el-select v-model="searchForm.is_blacklist" placeholder="请选择是否停用" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_blacklist_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="是否共享">
									<el-select v-model="searchForm.is_share" placeholder="请选择共享状态" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_share_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择状态" style="width: 100%;" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/resources/resources/ctsupplier')">
								<div>
									<el-button type="primary" size="mini"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/ctsupplier')"
										@click="addSupplierOpen">添加供应商</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table v-loading="loading" :data="tableData.data" style="width: 100%" row-key="id" border stripe
									ref="table" highlight-current-row @sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" align="center" width="50">
									</el-table-column>
									<el-table-column fixed prop="supplier_name" label="供应商名称" min-width="220">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.supplier_name }}</el-link>
										</template>
									</el-table-column>
									<el-table-column fixed prop="supplier_code" label="供应商编码" width="170">
									</el-table-column>
									<el-table-column prop="short_name" label="供应商简称" width="170">
									</el-table-column>
									<el-table-column prop="type" label="供应商类型" width="100">
									</el-table-column>
									<el-table-column prop="xingtu_short_name" label="星图简称" min-width="100">
										<template slot-scope="scope">
											{{ scope.row.xingtu_short_name ? scope.row.xingtu_short_name : '暂无' }}
										</template>
									</el-table-column>
									<el-table-column prop="dandelion_short_name" label="蒲公英简称" width="150">
										<template slot-scope="scope">
											{{ scope.row.dandelion_short_name ? scope.row.dandelion_short_name : '暂无' }}
										</template>
									</el-table-column>
									<el-table-column prop="is_payment" label="是否统一结算" width="100">
									</el-table-column>
									<el-table-column prop="payment_time" label="账期时间(天)" width="100">
									</el-table-column>
									<el-table-column prop="id_number" label="税号/身份证号" width="180">
										<template slot-scope="scope">
											<template>{{ scope.row.id_number ? scope.row.id_number : '暂无' }}</template>
										</template>
									</el-table-column>
									<el-table-column prop="is_share" label="是否共享资源" width="100">
									</el-table-column>
									<el-table-column prop="is_blacklist" label="是否停用" width="90">
									</el-table-column>
									<el-table-column prop="admin_id" label="添加人" width="80">
										<template slot-scope="scope">
											{{ scope.row.admin_id ? scope.row.admin_id : '暂无' }}
										</template>
									</el-table-column>
									<el-table-column align="center" prop="idcard_prove" label="营业执照" width="80">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.idcard_prove" target="_blank"
												v-if="scope.row.idcard_prove" style="font-size: 12px;">预览</el-link>
											<template v-else>暂无</template>
										</template>
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="150" sortable="custom">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" width="150" sortable="custom">
									</el-table-column>
									<el-table-column fixed="right" align="center" prop="status_txt" label="状态" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/editsupplier') || $parent.$parent.isAuthAction('admin/resources/resources/suppliersubmit') || $parent.$parent.isAuthAction('admin/resources/resources/delsupplie') || $parent.$parent.isAuthAction('admin/resources/resources/setdiscount') || $parent.$parent.isAuthAction('admin/resources/resources/setblacklist') || $parent.$parent.isAuthAction('admin/resources/resources/updatesupllistname')"
										min-width="200">
										<template slot-scope="scope">
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4)"
												@click="handleTableEditOpen(scope.row)"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/editsupplier')" type="text"
												:size="size">编辑</el-button>
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
												@click="handleTableCheckOpen(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/suppliersubmit')">提交审批</el-button>
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
												@click="handleTableDelOpen(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/delsupplie')">删除</el-button>
												<el-button :disabled="!(scope.row.status == 4)" @click="handleTableStopOpen(scope.row)" type="text"
												:size="size" v-if="$parent.$parent.isAuthAction('admin/resources/resources/setblacklist')">{{
													scope.row.is_blacklist == '是' ? '启用' : '停用' }}</el-button>
											<el-button :disabled="!(scope.row.status == 4)" @click="handleTableDiscountOpen(scope.row)"
												type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/setdiscount')">设置折扣</el-button>
											<el-button :disabled="!(scope.row.status == 4)" @click="handleInfoOpen(scope.row)" type="text"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/updatesupllistname')">变更信息</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[20, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加供应商-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="70%">
			<div class="drawer-header">
				<div class="header-title">
					<span v-if="formType == 'add'">添加供应商</span>
					<span v-else>编辑供应商</span>
					<i class="el-icon-close k-drawer-close" @click="closeForm"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="130px">
					<template v-if="formType == 'add' || (formType == 'edit' && formStatus != 4)">
						<el-steps :active="supplier_active" v-if="addForm.info.type == 2" finish-status="success" align-center
							style="margin-top: 20px;">
							<el-step title="基本信息"></el-step>
							<el-step title="联系人信息"></el-step>
							<el-step title="银行卡信息"></el-step>
							<el-step title="完成"></el-step>
						</el-steps>
						<el-steps :active="supplier_active" v-if="addForm.info.type != 2" finish-status="success" align-center
							style="margin-top: 20px;">
							<el-step title="基本信息"></el-step>
							<el-step title="联系人信息"></el-step>
							<el-step title="开票信息"></el-step>
							<el-step title="银行卡信息"></el-step>
							<el-step title="完成"></el-step>
						</el-steps>
					</template>
					<template v-else>
						<el-steps :active="supplier_active" finish-status="success" align-center style="margin-top: 20px;">
							<el-step title="基本信息"></el-step>
							<el-step title="联系人信息"></el-step>
							<el-step title="完成"></el-step>
						</el-steps>
					</template>
					<div class="addBox" v-show="supplier_active == 0">
						<el-form-item label="供应商类型" prop="info.type" key="type">
							<el-select v-model="addForm.info.type" placeholder="请选择" style="width: 100%;"
								:disabled="addForm.info.status == 4">
								<el-option v-for="item in options.type_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="供应商名称" prop="info.supplier_name" key="info.supplier_name">
							<el-input v-model="addForm.info.supplier_name" placeholder="请填写供应商名称" clearable @blur='supplierNameChange'
								:disabled="addForm.info.status == 4" maxlength="50" show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="供应商简称" prop="info.short_name" key="info.short_name">
							<el-input v-model="addForm.info.short_name" placeholder="请填写供应商简称" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="星图简称" prop="info.xingtu_short_name" key="info.xingtu_short_name">
							<el-input v-model="addForm.info.xingtu_short_name" placeholder="请输入该机构在星图平台展示的MCN机构名称" clearable
								maxlength="20" show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="蒲公英简称" prop="info.dandelion_short_name" key="dandelion_short_name">
							<el-input v-model="addForm.info.dandelion_short_name" placeholder="请输入该机构在蒲公英平台展示的MCN机构名称" clearable
								maxlength="20" show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="是否统一结算" prop="info.is_payment" key="is_payment">
							<el-radio-group v-model="addForm.info.is_payment">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>

						<el-form-item label="账期时间(天)" prop="info.payment_time" key="payment_time"
							v-if="addForm.info.is_payment == 1">
							<el-input v-model.number="addForm.info.payment_time" placeholder="请填写账期时间(天)" clearable></el-input>
						</el-form-item>

						<el-form-item :label="addForm.info.type != 2 ? '税号' : '身份证号'" prop="info.id_number" key="id_number"
							required>
							<el-input v-model="addForm.info.id_number"
								:placeholder="addForm.info.type != 2 ? '请填写公司税号' : '请填写收款人身份证号'" @blur='supplierNameChange'
								:disabled="addForm.info.status == 4" clearable maxlength="30" show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="是否为共享资源" prop="info.is_share" key="is_share">
							<el-radio-group v-model="addForm.info.is_share">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item :label="addForm.info.type == 2 ? '证照附件' : '营业执照'" prop="info.idcard_prove" key="idcard_prove"
							:required="addForm.info.type != 2">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.info.idcard_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'info', 'idcard_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'info', 'idcard_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
					</div>
					<div class="addBox" v-show="supplier_active == 1">
						<el-form-item label="姓名" prop="contacts.name" key="name">
							<el-input v-model="addForm.contacts.name" placeholder="请填写联系人姓名" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="联系方式" prop="contacts.pw" key="pw">
							<el-checkbox-group v-model="addForm.contacts.pw">
								<el-checkbox :label="1">手机号</el-checkbox>
								<el-checkbox :label="2">微信</el-checkbox>
							</el-checkbox-group>
						</el-form-item>

						<el-form-item label="手机号" prop="contacts.link_phone" key="link_phone"
							v-if="JSON.stringify(addForm.contacts) != '{}' && addForm.contacts.pw.includes(1)">
							<el-input v-model="addForm.contacts.link_phone" placeholder="请填写联系人手机号" clearable></el-input>
						</el-form-item>

						<el-form-item label="微信" prop="contacts.wechat" key="wechat"
							v-if="JSON.stringify(addForm.contacts) != '{}' && addForm.contacts.pw.includes(2)">
							<el-input v-model="addForm.contacts.wechat" placeholder="请填写联系人微信" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>

						<el-form-item label="邮箱" prop="contacts.email" key="email" :required="addForm.info.type != 2">
							<el-input v-model="addForm.contacts.email" placeholder="请填写联系人邮箱" clearable></el-input>
						</el-form-item>

						<el-form-item label="职位" prop="contacts.position" key="position" :required="addForm.info.type != 2">
							<el-input v-model="addForm.contacts.position" placeholder="请填写联系人职位" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>
					</div>
					<template v-if="formType == 'add' || (formType == 'edit' && formStatus != 4)">
						<div class="addBox" v-show="supplier_active == 2 && addForm.info.type != 2">
							<el-form-item label="公司">
								<el-input v-model="addForm.invoice.company_name" :disabled="true"></el-input>
							</el-form-item>
							<el-form-item label="税号">
								<el-input v-model="addForm.invoice.ird" :disabled="true"></el-input>
							</el-form-item>
							<el-form-item label="单位地址" prop="invoice.address" key="address" :required="invoiceRequired == 1">
								<el-input v-model="addForm.invoice.address" placeholder="请填写单位地址" clearable maxlength="80"
									show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="电话号码" prop="invoice.phone" key="phone" :required="invoiceRequired == 1">
								<el-input v-model="addForm.invoice.phone" placeholder="请填写电话号码" clearable></el-input>
							</el-form-item>
							<el-form-item label="开户行及支行" prop="invoice.bank_branch" key="bank_branch"
								:required="invoiceRequired == 1">
								<el-col :span="11">
									<el-select v-model="addForm.invoice.bank_of_deposit" filterable
										@change="requestZh('kpxx', addForm.invoice.bank_of_deposit, 'clear')" placeholder="请选择开户行" clearable
										style="width: 100%;">
										<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col>
								<el-col class="line" style="width:20px; text-align: center;">-</el-col>
								<el-col :span="12">
									<el-select v-model="addForm.invoice.bank_branch" filterable allow-create default-first-option
										placeholder="请选择支行" clearable style="width: 100%;">
										<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col>
							</el-form-item>
							<el-form-item label="银行卡号" prop="invoice.bank_card" key="invoice.bank_card"
								:required="invoiceRequired == 1">
								<el-input v-model="addForm.invoice.bank_card" placeholder="请填写银行卡号" clearable maxlength="30"
									show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="发票类型" prop="invoice.invoice_type" key="invoice_type"
								:required="invoiceRequired == 1">
								<el-radio-group v-model="addForm.invoice.invoice_type">
									<el-radio :label="1">普票</el-radio>
									<el-radio :label="2">专票</el-radio>
									<el-radio :label="3">形式发票</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="发票率" prop="invoice.invoice_rate" key="invoice.invoice_rate"
								:required="invoiceRequired == 1">
								<el-input v-model="addForm.invoice.invoice_rate" placeholder="请填写发票率" clearable>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>

							<el-form-item label="开户许可证" prop="invoice.invoice_prove" key="invoice_prove"
								:required="invoiceRequired == 1">
								<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.invoice_prove"
									:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'invoice_prove', true)" :auto-upload="false"
									:on-change="(file) => changeRequired(file, 'invoice', 'invoice_prove', true)" :on-preview="viewImg">
									<el-button slot="trigger" size="mini">选取文件</el-button>
									<span style="margin-left: 10px; cursor: pointer;">
										<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
											<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
										</el-tooltip>
									</span>
								</el-upload>
							</el-form-item>
							<el-form-item label="一般纳税人证明" prop="invoice.taxpayer_prove" key="taxpayer_prove"
								:required="invoiceRequired == 1">
								<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.taxpayer_prove"
									:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'taxpayer_prove', true)" :auto-upload="false"
									:on-change="(file) => changeRequired(file, 'invoice', 'taxpayer_prove', true)" :on-preview="viewImg">
									<el-button slot="trigger" size="mini">选取文件</el-button>
									<span style="margin-left: 10px; cursor: pointer;">
										<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
											<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
										</el-tooltip>
									</span>
								</el-upload>
							</el-form-item>
							<el-form-item label="发票证明" prop="invoice.fp_attachment" key="fp_attachment"
								:required="invoiceRequired == 1">
								<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.fp_attachment"
									:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'fp_attachment', true)" :auto-upload="false"
									:on-change="(file) => changeRequired(file, 'invoice', 'fp_attachment', true)" :on-preview="viewImg">
									<el-button slot="trigger" size="mini">选取文件</el-button>
									<span style="margin-left: 10px; cursor: pointer;">
										<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
											<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
										</el-tooltip>
									</span>
								</el-upload>
							</el-form-item>
							<div style="margin-top: 20px; color: #F56C6C;">本页信息可选填，若填写需要填写完整后再进行下一步</div>
						</div>
						<div class="addBox"
							v-show="(supplier_active == 3 && addForm.info.type != 2) || (supplier_active == 2 && addForm.info.type == 2)">
							<el-form-item label="支付方式" key="pay_type">
								<el-select v-model="addForm.bankcard.pay_type" placeholder="请选择" clearable style="width: 100%;"
									disabled>
									<el-option label="对公" :value="1"></el-option>
									<el-option label="对私" :value="2"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="开户名" prop="bankcard.real_name" key="real_name" :required="bankcardRequired == 1">
								<el-input v-model="addForm.bankcard.real_name" placeholder="请填写开户名" clearable :disabled='realNameDis'
									maxlength="30" show-word-limit></el-input>
							</el-form-item>

							<el-form-item label="开户行及支行" prop="bankcard.bankcard_branch" key="bankcard_branch"
								:required="bankcardRequired == 1">
								<el-col :span="11">
									<el-select v-model="addForm.bankcard.bankcard_of_deposit" filterable
										@change="requestZh('yhk', addForm.bankcard.bankcard_of_deposit, 'clear')" placeholder="请选择开户行"
										clearable style="width: 100%;">
										<el-option v-for="item in options.khh_options2" :key="item.id" :label="item.bank_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col>
								<el-col class="line" style="width:20px; text-align: center;">-</el-col>
								<el-col :span="11">
									<el-select v-model="addForm.bankcard.bankcard_branch" filterable allow-create default-first-option
										placeholder="请选择支行" clearable style="width: 100%;">
										<el-option v-for="item in options.zh_options2" :key="item.id" :label="item.bank_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col>
							</el-form-item>

							<el-form-item label="银行卡号" prop="bankcard.bank_card_num" key="bank_card_num"
								:required="bankcardRequired == 1">
								<el-input v-model="addForm.bankcard.bank_card_num" placeholder="请填写银行卡号" clearable maxlength="30"
									show-word-limit></el-input>
							</el-form-item>

							<el-form-item label="开户证明" prop="bankcard.bank_prove" key="bank_prove" :required="bankcardRequired == 1">
								<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.bankcard.bank_prove"
									:on-remove="(file) => handleRemoveUpload(file, 'bankcard', 'bank_prove', true)" :auto-upload="false"
									:on-change="(file) => changeRequired(file, 'bankcard', 'bank_prove', true)" :on-preview="viewImg">
									<el-button slot="trigger" size="mini">选取文件</el-button>
									<span style="margin-left: 10px; cursor: pointer;">
										<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
											<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
										</el-tooltip>
									</span>
								</el-upload>
							</el-form-item>
							<div style="margin-top: 20px; color: #F56C6C;">本页信息可选填，若填写需要填写完整后再进行下一步</div>
						</div>
					</template>
					<div class="addBox" v-show="(supplier_active == 4 && addForm.info.type != 2 && formType == 'add') ||
						(supplier_active == 3 && addForm.info.type == 2 && formType == 'add') ||
						(formType == 'edit' && formStatus == 4 && supplier_active == 2) ||
						(supplier_active == 4 && addForm.info.type != 2 && formType == 'edit' && formStatus != 4) ||
						(supplier_active == 3 && addForm.info.type == 2 && formType == 'edit' && formStatus != 4)">
						<div class="supplierEnd">
							<i class="el-icon-success" style="color: #67C23A; font-size: 60px;"></i>
							<p v-if="formType == 'add'" class="tips">新建供应商已提交成功！</p>
							<p v-if="formType == 'edit'" class="tips">供应商信息已修改成功！</p>
							<div class="btn">
								<!-- <el-button type="primary" size="mini">再次新增</el-button> -->
								<el-button size="mini" @click="closeForm">确定</el-button>
							</div>
						</div>
					</div>
				</el-form>
			</div>
			<template v-if="formType == 'add' || (formType == 'edit' && formStatus != 4)">
				<div class="drawer-footer"
					v-show="(supplier_active != 4 && addForm.info.type != 2) || (supplier_active != 3 && addForm.info.type == 2)">
					<el-button type="primary" @click="next()" :size='size'
						v-show="(supplier_active < 3 && addForm.info.type != 2) || (supplier_active < 2 && addForm.info.type == 2)">下一步</el-button>
					<el-button @click="prev()" :size='size' v-show="supplier_active > 0 && supplier_active < 4">上一步</el-button>
					<el-button type="primary" @click="addCtsupplier" :size='size'
						v-show="(supplier_active == 3 && addForm.info.type != 2) || (supplier_active == 2 && addForm.info.type == 2)">提交</el-button>
					<el-button :size='size' @click="closeForm">取消</el-button>
				</div>
			</template>
			<template v-else>
				<div class="drawer-footer" v-show="supplier_active != 2">
					<el-button type="primary" @click="next()" :size='size' v-show="supplier_active == 0">下一步</el-button>
					<el-button @click="prev()" :size='size' v-show="supplier_active == 1">上一步</el-button>
					<el-button type="primary" @click="addCtsupplier" :size='size' v-show="supplier_active == 1">提交</el-button>
					<el-button :size='size' @click="closeForm">取消</el-button>
				</div>
			</template>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<el-dialog title="折扣/返点" :close-on-click-modal="false" :visible.sync="dialogDiscountVisible" width="30%"
			v-loading="loading">
			<el-form ref="discountForm" :model="discountForm" :rules="rules.discountForm" :size="size" label-width="100px">
				<p style="margin-bottom:15px;color:red;">注意：该供应商下的所有资源是否应用折扣/返点,取决于【是否覆盖】。</p>
				<el-form-item label="设置类型">
					<el-radio-group v-model="discountForm.type">
						<el-radio-button label="zhekou">折扣</el-radio-button>
						<el-radio-button label="fandian">返点</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="折扣比例" prop="discount" v-if="discountForm.type == 'zhekou'">
					<el-input v-model="discountForm.discount">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="返点比例" prop="point" v-if="discountForm.type == 'fandian'">
					<el-input v-model="discountForm.point">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="是否覆盖">
					<el-radio-group v-model="discountForm.is_discount">
						<el-radio :label="1">否</el-radio>
						<el-radio :label="0">是</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" @click="dialogDiscountVisible = false">取 消</el-button>
				<el-button type="primary" :size="size" @click="setDiscount('discountForm')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="centerDialogVisible" v-loading="loading" width="60%">
			<div class="k-page-common"
				style="max-height:calc(70vh - 100px); overflow: auto; height: auto !important; padding-bottom: 20px;">
				<div style="color: #F56C6C; padding-bottom: 10px;">
					该供应商是以下资源的默认供应商，请先修改默认后再停用!
				</div>
				<ul class="dialogLi">
					<li v-for="(item, index) in logList" :key="index">{{ item }}</li>
				</ul>
			</div>
		</el-dialog>
		<el-dialog title="基础信息修改" :close-on-click-modal="false" :visible.sync="infoDisabled" width="50%"
			v-loading="loading">
			<el-form ref="oneInfoData" :model="oneInfoData" :rules="rules.oneInfoData" :size="size" label-width="100px">
				<p style="margin-bottom:15px;color:red;">重要提示：</p>
				<p style="margin-bottom:15px;color:red;">1.基础信息修改将直接影响历史数据，且无法恢复，请谨慎操作。</p>
				<p style="margin-bottom:15px;color:red;">2.仅限供应商名称存在错别字、特殊符号不一致等轻微修正，供应商主体需保持不变。</p>
				<p style="margin-bottom:15px;color:red;">3.修改前请仔细核对供应商信息是否与发票、银行账户完全一致，信息不符将无法通过修改。</p>
				<p style="margin-bottom:15px;color:red;">4.如不希望影响历史数据，建议新建相关信息。</p>
				<el-divider content-position="center">供应商信息</el-divider>
				<el-form-item label="供应商名称" prop="info.supplier_name">
					<el-input v-model="oneInfoData.info.supplier_name"></el-input>
				</el-form-item>
				<el-form-item label="供应商简称" prop="info.short_name">
					<el-input v-model="oneInfoData.info.short_name"></el-input>
				</el-form-item>
				<el-form-item label="税号" prop="info.id_number">
					<el-input v-model="oneInfoData.info.id_number"></el-input>
				</el-form-item>
				<template v-if="oneInfoData.info.type!=2">
					<el-divider content-position="center">发票信息</el-divider>
					<el-form-item label="公司名称" >
						<el-input v-model="oneInfoData.invoice.company_name" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="税号" >
						<el-input v-model="oneInfoData.invoice.ird" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="电话" prop="invoice.phone">
						<el-input v-model="oneInfoData.invoice.phone"></el-input>
					</el-form-item>
					<el-form-item label="地址" prop="invoice.address">
						<el-input v-model="oneInfoData.invoice.address"></el-input>
					</el-form-item>
				</template>
				<el-divider content-position="center">银行卡信息</el-divider>
				<el-form-item label="开户名">
					<el-input v-model="oneInfoData.bankcard.real_name" :disabled="true"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" @click="infoDisabled = false">取 消</el-button>
				<el-button type="primary" :size="size" @click="updateSuppInfo('oneInfoData')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			centerDialogVisible: false,
			logList: [],
			dialogDiscountVisible: false,
			dialogImageUrl: '',
			dialogVisibleImg: false,
			addFormVisiable: false,
			loading: true,
			activeName: 'first',
			size: 'mini',
			options: {
				type_options: [
					{
						value: 1,
						label: 'MCN机构'
					}, {
						value: 2,
						label: '个人'
					}, {
						value: 3,
						label: '代理'
					}
				],
				is_payment_options: [
					{
						value: 1,
						label: '是'
					}, {
						value: 2,
						label: '否'
					}
				],
				is_share_options: [
					{
						value: 1,
						label: '是'
					}, {
						value: 2,
						label: '否'
					}
				],
				is_blacklist_options: [
					{
						value: 1,
						label: '是'
					}, {
						value: 2,
						label: '否'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				khh_options: [],//开户行-开票信息
				zh_options: [],//支行-开票信息
				khh_options2: [],//开户行-银行卡
				zh_options2: []//支行-银行卡
			},
			supplier_active: 0,
			searchForm: {
				type: '',
				supplier_code: '',
				supplier_name: '',
				short_name: '',
				status: '',
				is_share: '',
				is_payment: '',
				is_blacklist: '',
				id_number: ''
			},
			resetSearch: {
				type: '',
				supplier_code: '',
				supplier_name: '',
				short_name: '',
				status: '',
				is_share: '',
				is_payment: '',
				is_blacklist: '',
				id_number: ''
			},
			formType: 'add',
			formStatus: '',
			addForm: {
				info: {
					type: '',
					supplier_name: '',
					short_name: '',
					xingtu_short_name: '',
					dandelion_short_name: '',
					is_payment: 2,
					payment_time: '',
					id_number: '',
					is_share: 1,
					idcard_prove: []
				},
				contacts: {
					name: '',
					pw: [],
					link_phone: '',
					wechat: '',
					email: '',
					position: '',
				},
				invoice: {
					company_name: '',
					ird: '',
					address: '',
					phone: '',
					bank_of_deposit: '',
					bank_branch: '',
					bank_card: '',
					invoice_type: '',
					invoice_rate: '',
					invoice_prove: [],
					taxpayer_prove: [],
					fp_attachment: [],
				},
				bankcard: {
					pay_type: 1,
					real_name: '',
					bankcard_of_deposit: '',
					bankcard_branch: '',
					bank_card_num: '',
					bank_prove: []
				}
			},
			discountForm: {
				id: '',
				type: 'zhekou',
				discount: '',
				point: '',
				is_discount: 1
			},
			rules: {
				oneInfoData:{
					'info.supplier_name':[{ required: true, message: '请填写供应商名称', trigger: ['change'] }],
					'info.short_name':[{ required: true, message: '请填写供应商简称', trigger: ['change'] }],
					'info.id_number':[{ required: true, message: '请填写税号', trigger: ['change'] }],
					'invoice.phone':[{ required: true, message: '请填写发票联系电话', trigger: ['change'] }],
					'invoice.address':[{ required: true, message: '请填写发票地址', trigger: ['change'] }],
				},
				addForm: {
					info: {
						'type': [
							{ required: true, message: '请选择供应商类型', trigger: ['change'] }
						],
						'supplier_name': [
							{ required: true, message: '请填写供应商名称', trigger: ['change', 'blur'] },
							{ max: 50, message: '请填写正确的供应商名称，长度不超过 50', trigger: ['change', 'blur'] }
						],
						'short_name': [
							{ required: true, max: 20, message: '请填写正确的供应商简称，长度不超过 20', trigger: ['change', 'blur'] }
						],
						'is_payment': [
							{ required: true, message: '请选择是否统一结算', trigger: ['change', 'blur'] }
						],
						'payment_time': [
							{ required: true, message: '请填写账期时间(天)', trigger: ['change', 'blur'] },
							{ type: 'number', message: '账期时间必须为数字值', trigger: ['change', 'blur'] }
						],
						'id_number': [
							{
								validator: (rule, value, callback) => {
									let regExp = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
									if (!value) {
										if (this.addForm.info.type != 2) {
											callback(new Error('请填写税号'));
										} else {
											callback(new Error('请填写身份证号'));
										}
									} else if (!regExp.test(value) && this.addForm.info.type == 2) {
										callback(new Error('请填写正确的身份证号'));
									} else {
										callback();
									}
								}
							}, {
								pattern: /^[A-Za-z0-9]+$/,
								message: '只能包含字母和数字',
								trigger: ['change', 'blur'],
							}
						],
						'idcard_prove': [
							{
								validator: (rule, value, callback) => {
									if (this.addForm.info.idcard_prove.length < 1 && this.addForm.info.type != 2) {
										callback(new Error('请上传营业执照'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						]
					},
					contacts: {
						'name': [
							{ required: true, message: '请填写联系人姓名', trigger: ['change', 'blur'] },
							{ max: 20, message: '请填写正确的联系人姓名，长度不超过 20', trigger: ['change', 'blur'] }
						],
						'pw': [
							{ required: true, message: '请选择联系类型', trigger: ['change', 'blur'] }
						],
						'link_phone': [
							{ required: true, message: '请填写联系人电话', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请填写电话号码'));
									} else {
										const reg = /^1[3-9]\d{9}$/; // 中国大陆手机号码正则表达式
										if (!reg.test(value) && value) {
											callback(new Error('请输入有效的电话号码'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'wechat': [
							{ required: true, message: '请填写联系人微信', trigger: ['change', 'blur'] }
						],
						'email': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.addForm.info.type != 2) {
										callback(new Error('请填写联系人邮箱'));
									} else {
										const reg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})*$/; // 基本的邮箱地址正则表达式
										if (!reg.test(value)) {
											callback(new Error('请输入有效的电子邮件地址'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'position': [{
							validator: (rule, value, callback) => {
								if (!value && this.addForm.info.type != 2) {
									callback(new Error('请填写联系人职位'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}],
					},
					invoice: {
						'address': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请填写单位地址'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'phone': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请填写电话号码'));
									} else {
										const reg = /^((\d{3,4}-)?\d{7,8})|1[3-9]\d{9}$/; // 中国大陆手机号码正则表达式
										if (!reg.test(value) && value) {
											callback(new Error('请输入有效的手机号或座机号'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bank_branch': [
							{
								validator: (rule, value, callback) => {
									if (!this.addForm.invoice.bank_of_deposit && this.invoiceRequired == 1) {
										callback(new Error('请选择开户行'));
									} else if (!this.addForm.invoice.bank_branch && this.invoiceRequired == 1) {
										callback(new Error('请选择支行'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bank_card': [
							{
								validator: (rule, value, callback) => {
									const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请填写银行卡号'));
									} else {
										if (!regex.test(value) && this.invoiceRequired == 1) {
											callback(new Error('请填写正确的银行卡号'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'invoice_type': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请选择发票类型'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'invoice_rate': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.invoiceRequired == 1) {
										callback(new Error('请填写发票率'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'invoice_prove': [
							{
								validator: (rule, value, callback) => {
									if (this.addForm.invoice.invoice_prove.length < 1 && this.invoiceRequired == 1) {
										callback(new Error('请上传开户许可证'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'taxpayer_prove': [
							{
								validator: (rule, value, callback) => {
									if (this.addForm.invoice.taxpayer_prove.length < 1 && this.invoiceRequired == 1) {
										callback(new Error('请上传一般纳税人证明'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'fp_attachment': [
							{
								validator: (rule, value, callback) => {
									if (this.addForm.invoice.fp_attachment.length < 1 && this.invoiceRequired == 1) {
										callback(new Error('请上传发票证明'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						]
					},
					bankcard: {
						'real_name': [
							{
								validator: (rule, value, callback) => {
									if (!value && this.bankcardRequired == 1) {
										callback(new Error('请填写开户名'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bankcard_branch': [
							{
								validator: (rule, value, callback) => {
									if (!this.addForm.bankcard.bankcard_of_deposit && this.bankcardRequired == 1) {
										callback(new Error('请选择开户行'));
									} else if (!this.addForm.bankcard.bankcard_branch && this.bankcardRequired == 1) {
										callback(new Error('请选择支行'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}

						],
						'bank_card_num': [
							{
								validator: (rule, value, callback) => {
									const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
									if (!value && this.bankcardRequired == 1) {
										callback(new Error('请填写银行卡号'));
									} else {
										if (!regex.test(value) && this.bankcardRequired == 1) {
											callback(new Error('请填写正确的银行卡号'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bank_prove': [
							{
								validator: (rule, value, callback) => {
									if (this.addForm.bankcard.bank_prove.length < 1 && this.bankcardRequired == 1) {
										callback(new Error('请上传开户证明'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						]
					}
				},
				discountForm: {
					discount: [
						{ required: true, message: '请填写折扣比例', trigger: ['change'] },
						{
							validator: (rule, value, callback) => {
								const regex = /^(100(\.0{0,2})?|[1-9]?\d(\.\d{1,2})?)$/;
								if (regex.test(value)) {
									// 转换为数字后检查是否在范围内
									const numValue = parseFloat(value);
									if (numValue >= 0 && numValue <= 100) {
										return callback();
									}
								}
								callback(new Error('请输入0.00到100之间的数字，并且最多保留两位小数'));
							}, trigger: 'blur'
						}],// 当失去焦点时触发验证
					point: [
						{ required: true, message: '填写返点比例', trigger: ['change'] },
						{
							validator: (rule, value, callback) => {
								const regex = /^(100(\.0{0,2})?|[1-9]?\d(\.\d{1,2})?)$/;
								if (regex.test(value)) {
									// 转换为数字后检查是否在范围内
									const numValue = parseFloat(value);
									if (numValue >= 0 && numValue <= 100) {
										return callback();
									}
								}
								callback(new Error('请输入0.00到100之间的数字，并且最多保留两位小数'));
							}, trigger: 'blur'
						}], // 当失去焦点时触发验证
				}

			},
			oneInfoData:{
				info:{},
				invoice:{},
				bankcard:{}
			},
			infoDisabled:false,
			tableData: {
				total: 0,
				pagesize: 20,
				page: 1,
				data: []
			},
			invoiceRequired: 0,
			bankcardRequired: '',
			realNameDis: false//银行卡开户名可修改
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
		'addForm.info.type' (newValue) {
			if (this.$refs['addForm']) {
				this.$refs['addForm'].clearValidate();
				if (this.addForm.info.type != 2) {
					this.realNameDis = true
					this.addForm.bankcard.pay_type = 1
				} else {
					this.realNameDis = false
					this.addForm.bankcard.pay_type = 2
				}
			}
		},
		'formType': {
			handler (newVal, oldVal) {
				this.supplier_active = 0
			}
		},
		'addForm.invoice': {
			immediate: true,
			handler (newVal, oldVal) {
				this.getRequiredInvoice()
			},
			deep: true
		},
		'addForm.bankcard': {
			handler (newVal, oldVal) {
				// 这里执行相应的处理逻辑
				this.getRequiredBankcard()
			},
			deep: true
		},
		'supplier_active': {
			handler (newVal, oldVal) {
				if (this.formType == 'add') {
					//此处为添加是逻辑，编辑时回显数据时就请求支行
					if (this.supplier_active == 2) {
						if (this.addForm.info.type != 2) {
							this.requestKhh('kpxx')
						} else {
							this.requestKhh('yhk')
						}
					} else if (this.supplier_active == 3) {
						this.requestKhh('yhk')
					}
				}
			},
		}
	},
	mounted: function () {
		//   this.handleSearch(this.searchForm);
	},
	created () {
	},
	methods: {
		updateSuppInfo(formName){
			this.$refs[formName].validate((valid) => {
          if (valid) {
						this.infoDisabled = false
            this.$api.post('/admin/resources/resources/updatesupllistname', this.oneInfoData).then(res => {
							if (res.code == 0) {
								this.$message.success('信息变更成功');
							}else{
								this.$message.error(res.msg);
							}
						})
          }
        });
		},
		// 修改基础信息
		handleInfoOpen (row) {
			// 获取基础信息
			this.$api.get('/admin/resources/resources/supplierinfo', { id: row.id }).then(res => {
				if (res.code == 0) {
					this.oneInfoData = res.data
					this.infoDisabled = true
				}
			})
		},
		// 停用供应商
		handleTableStopOpen (row) {
			var status = row.is_blacklist == '是' ? '启用' : '停用'
			var setvalue = row.is_blacklist == '是' ? '否' : '是'
			this.$confirm('此操作将【' + status + '】该供应商, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.$api.post('/admin/resources/resources/setblacklist', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$set(data[index], 'is_blacklist', setvalue);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该供应商设置成功！',
							type: 'success'
						});
					} else {
						this.logList = res.data
						this.centerDialogVisible = true
					}
				})
			}.bind(this))
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		setDiscount (form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/setdiscount', this.discountForm).then(res => {
						if (res.code == 0) {
							this.$message.success('设置成功')
							this.dialogDiscountVisible = false
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			})

		},
		// 打开折扣弹窗
		handleTableDiscountOpen (row) {
			this.$api.get('/admin/resources/resources/getsupplierinfo', { id: row.id }).then(res => {
				if (res.code == 0) {
					this.discountForm.discount = res.data.discount
					this.discountForm.point = res.data.point
					this.discountForm.id = row.id
					this.dialogDiscountVisible = true
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//实时验证开票信息必填
		getRequiredInvoice () {
			let reqinvoice = []
			let arr = ['invoice_prove', 'taxpayer_prove', 'fp_attachment']
			for (const key in this.addForm.invoice) {
				if (key == 'company_name' || key == 'ird') {
				} else {
					if (arr.indexOf(key) != -1 && this.addForm.invoice[key].length > 0) {
						//验证文件长度
						reqinvoice.push('1')
					} else if (arr.indexOf(key) == -1 && this.addForm.invoice[key]) {
						reqinvoice.push('1')
					}
				}
			}
			if (reqinvoice.length > 0) {
				this.invoiceRequired = 1
			} else {
				this.invoiceRequired = 0
			}
		},
		//实时验证银行卡必填
		getRequiredBankcard () {
			let reqbankcard = []
			for (const key in this.addForm.bankcard) {
				if (key == 'pay_type' || key == 'real_name') {
				} else if (key == 'bank_prove') {
					if (this.addForm.bankcard.bank_prove.length > 0 && this.supplier_active >= 2) {
						reqbankcard.push('1')
					}
				}
				else {
					if (this.addForm.bankcard[key] && this.supplier_active >= 2) {
						reqbankcard.push('1')
					}
				}
			}
			if (reqbankcard.length > 0) {
				this.bankcardRequired = 1
			}
		},
		//供应商名称关联银行卡开户名
		supplierNameChange () {
			this.addForm.bankcard.real_name = this.addForm.info.supplier_name
			this.addForm.invoice.company_name = this.addForm.info.supplier_name
			this.addForm.invoice.ird = this.addForm.info.id_number
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/supllist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false;
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		clearAddForm () {
			this.addForm = {
				info: {
					type: '',
					supplier_name: '',
					short_name: '',
					xingtu_short_name: '',
					dandelion_short_name: '',
					is_payment: 2,
					payment_time: '',
					id_number: '',
					is_share: 1,
					idcard_prove: []
				},
				contacts: {
					name: '',
					pw: [],
					link_phone: '',
					wechat: '',
					email: '',
					position: '',
				},
				invoice: {
					company_name: '',
					ird: '',
					address: '',
					phone: '',
					bank_of_deposit: '',
					bank_branch: '',
					bank_card: '',
					invoice_type: '',
					invoice_rate: '',
					invoice_prove: [],
					taxpayer_prove: [],
					fp_attachment: [],
				},
				bankcard: {
					pay_type: 1,
					real_name: '',
					bankcard_of_deposit: '',
					bankcard_branch: '',
					bank_card_num: '',
					bank_prove: []
				}
			}
			this.invoiceRequired = 0
			this.bankcardRequired = 0
		},
		// 添加供应商弹窗
		addSupplierOpen () {
			this.formType = 'add'
			this.supplier_active = 0
			this.clearAddForm()
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
			this.loading = false
		},
		//获取开户行
		requestKhh (type) {
			this.$api.get('/admin/resources/resources/getbankname').then(res => {
				if (res.code === 0) {
					if (type == 'kpxx') {
						this.options.khh_options = res.data;
					} else if (type == 'yhk') {
						this.options.khh_options2 = res.data;
					}
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取支行
		requestZh (type, id, changetype) {
			//changetype为clear则清空关联，keep为编辑状态下默认的值不清空
			if (changetype == 'clear') {
				if (type == 'kpxx') {
					this.addForm.invoice.bank_branch = '';
				} else if (type == 'yhk') {
					this.addForm.bankcard.bankcard_branch = '';
				}
			}
			this.$api.get('/admin/resources/resources/getbankname', { id: id }).then(res => {
				if (res.code === 0) {
					if (type == 'kpxx') {
						this.options.zh_options = res.data;
					} else if (type == 'yhk') {
						this.options.zh_options2 = res.data;
					}
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//下一步
		next () {
			var keys = []
			if (this.supplier_active == 0) {
				keys = Object.keys(this.addForm.info).map(key => `info.${key}`);
			} else if (this.supplier_active == 1) {
				keys = Object.keys(this.addForm.contacts).map(key => `contacts.${key}`);
			} else if (this.supplier_active == 2 && this.addForm.info.type != 2) {
				keys = Object.keys(this.addForm.invoice).map(key => `invoice.${key}`);
			}

			const fieldsToValidate = keys; // 需要验证的字段名数组
			var allValid = [];
			fieldsToValidate.forEach(field => {
				this.$refs['addForm'].validateField(field, (err) => {
					// 如果某个字段验证失败，处理错误并决定是否继续验证其他字段
					if (err) {
						allValid.push(1)
						return
					}
				});
			});
			// 所有字段验证完成后，检查allValid的值
			if (allValid.length <= 0) {
				this.supplier_active++
				this.$nextTick(() => {
					this.$refs['addForm'].clearValidate();
				});
			}

		},
		//上一步
		prev () {
			if (this.supplier_active-- < 1) this.supplier_active = 0;
		},
		//提交
		addCtsupplier () {
			if (this.addForm.info.is_payment == 2) {
				this.addForm.info.payment_time = ''
			}
			const formData = new FormData()
			let arr = ['idcard_prove', 'invoice_prove', 'taxpayer_prove', 'fp_attachment', 'bank_prove']
			for (const keyp in this.addForm) {
				if (keyp != 'supplier_code') {
					for (const key in this.addForm[keyp]) {
						if (arr.indexOf(key) != -1) {
							if (this.addForm[keyp][key].length > 0) {
								this.addForm[keyp][key].forEach(item => {
									formData.append(key, item)
								})
							} else {
								formData.append(key, '')
							}
						} else if (key == 'pw') {
							this.addForm[keyp][key].forEach((item, index) => {
								formData.append(key, item);
							})
						} else {
							formData.append(key, this.addForm[keyp][key]);
						}
					}
				} else {
					formData.append(keyp, this.addForm[keyp]);
				}
			}
			this.$refs['addForm'].validate((valid) => {
				if (valid) {
					this.loading = true
					//通过校验进入下一步
					if (this.formType == 'add') {
						this.$api.post('/admin/resources/resources/ctsupplier', formData).then(res => {
							if (res.code === 0) {
								this.supplier_active++
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					} else {
						this.$api.post('/admin/resources/resources/editsupplier', formData).then(res => {
							if (res.code === 0) {
								this.supplier_active++
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					}
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			})
		},
		//点击查看大图
		viewImg (file) {
			if (!file.url) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.url)
				} else {
					this.dialogImageUrl = file.url;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this.addForm[formobj][field] = [file.raw]
			} else {
				this.addForm[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this.addForm[formobj][field] = []
			} else {
				this.addForm[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this.addForm[formobj][field], index)
					}
				}.bind(this))
			}

		},
		//编辑弹窗
		handleTableEditOpen (row) {
			this.supplier_active = 0
			this.loading = true
			this.$api.get('/admin/resources/resources/supplierinfo', { id: row.id }).then(res => {
				if (res.code == 0) {
					this.formType = 'edit'
					this.formStatus = row.status
					this.invoiceRequired = 0
					this.addForm.supplier_code = res.data.supplier_code

					//银行卡信息
					this.addForm.bankcard = res.data.bankcard
					//银行卡开户名是否可修改
					if (this.addForm.info.type != 2) {
						this.realNameDis = true
					} else {
						this.realNameDis = false
					}
					if (this.addForm.bankcard.bank_card_num) {
						//银行卡信息任意一项有值则必填，此处只判断银行卡号
						this.bankcardRequired = 1
					}
					//供应商信息
					this.addForm.info = res.data.info
					//联系人
					this.addForm.contacts = res.data.contacts

					//发票信息
					if (JSON.stringify(res.data.invoice) === "{}") {
						this.addForm.invoice = {
							address: '',
							phone: '',
							bank_of_deposit: '',
							bank_branch: '',
							bank_card: '',
							invoice_type: '',
							invoice_rate: '',
							invoice_prove: [],
							taxpayer_prove: [],
							fp_attachment: [],
						}
					} else {
						this.addForm.invoice = res.data.invoice
					}

					if (this.addForm.invoice.bank_card) {
						//银行卡信息任意一项有值则必填，此处只判断银行卡号
						this.invoiceRequired = 1
					}
					this.requestKhh('kpxx')
					if (this.addForm.invoice.bank_of_deposit) {
						this.requestZh('kpxx', this.addForm.invoice.bank_of_deposit, 'keep')
					}
					this.requestKhh('yhk')
					if (this.addForm.bankcard.bankcard_of_deposit) {
						this.requestZh('yhk', this.addForm.bankcard.bankcard_of_deposit, 'keep')
					}
					this.addFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		closeForm () {
			this.invoiceRequired = 0
			this.bankcardRequired = 0
			this.addFormVisiable = false
			this.formStatus = ''
			if (this.formType == 'edit') {
				this.clearAddForm()
				this.$nextTick(() => {
					this.$refs['addForm'].clearValidate();
				});
			}
			this.handleSearch(this.searchForm)
		},
		//提交审批
		handleTableCheckOpen (row) {
			this.loading = true
			this.$api.post('/admin/resources/resources/suppliersubmit', { supplier_code: row.supplier_code }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.supplier_code == item.supplier_code) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该供应商信息已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//删除供应商
		handleTableDelOpen (row) {
			this.$confirm('此操作将永久删除该供应商, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delsupplier', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该供应商已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'SupplierDetail',
				query: { id: row.id, set_id: 4, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (from.path != '/supplierDetail') {
				vm.reset()
			}
		});
	}
}
</script>
<style scoped>
.addBox {
	padding: 50px 30px 0;
}

.dialog-content {
	max-height: 200px;
	/* 设置最大高度 */
	overflow-y: auto;
	/* 启用垂直滚动条 */
}
</style>